import Surveys from '../surveys/Surveys.vue';
import Notifications from '../notifications/Notifications.vue';
import Carousel from '../../../sharedComponents/carousel/Carousel.vue';
import statusColors from '../../../utils/status-colors';

export default {
  data() {
    return {
      pagePers: null,
      pageRules: null,
      dialogPers: false,
      dialogRules: false,
      checkedRules: false,
      checkedPers: false,
      promocode: '',
      promoLink: false,
      loadUserData: false,
      // points: 18300, // Заработанные баллы
      // тестовые данные для вёрстки
      // statuses: [
      //  { name: 'BASIC', points: 0, percent: '-' },
      //  { name: 'SILVER', points: 10000, percent: '5' },
      //  { name: 'GOLD', points: 20000, percent: '10' },
      //  { name: 'PLATINUM', points: 50000, percent: '20' },
      // ],
      /** Список гарантий */
      certificates: [],
      count: {
        guaranties: 0,
        installations: 0,
        utilizations: 0,
      },
    };
  },
  components: {
    Surveys,
    Notifications,
    Carousel,
  },
  computed: {
    progressWidth() {
      // const maxPoints = 50000; // Максимальное количество баллов для статуса PLATINUM
      let percent = 0;
      if (this.statuses) {
        this.statuses.forEach((status) => {
          percent += status.current_percent;
        });
      }
      return Math.min(percent, 100); // Ограничиваем значение 100%
    },
    user() {
      return this.$store.state.user;
    },
    points() {
      return this.$store.state.user.sale_sum ?? 0;
    },
    purses() {
      return this.$store.state.purses;
    },
    requirePers() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_pers === true
        && state.user
        && !state.user.pers_at
      );
    },
    requireRules() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_rules === true
        && state.user
        && this.$store.state.agreedRules === false
      );
    },
    account() {
      return this.$store.state.user.account;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userIsChecked() {
      return this.$store.state.user ? this.$store.state.user.is_checked : null;
    },
    isBlocked() {
      return !!(
        this.$store.state.user && this.$store.state.user.blocked_at !== null
      );
    },
    hasSurvey() {
      return this.$store.state.surveys.hasSurvey;
    },
    hasNotifications() {
      return this.$store.state.notifications.hasNotifications;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    settings() {
      return this.$store.state.settings;
    },
    statuses() {
      return this.$store.state.statuses;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    bannersGroup() {
      return this.$store.state.banners.group || null;
    },
    taxes() {
      return this.$store.state.settings.taxes === true;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    salesCount() {
      return this.$store.state.sales.sales.length || 0;
    },
    objectsCount() {
      return this.$store.state.objects.objects?.length || 0;
    },
    installationsCount() {
      return this.$store.state.installations.installations.length || this.count.installations;
    },
    utilizationsCount() {
      return this.$store.state.utilizations.utilizations.length || this.count.utilizations;
    },
    guarantiesCount() {
      return this.count.guaranties;
    },
    module_has_guaranties() {
      if (!this.user) {
        return false;
      }
      return this.user.role_settings.modules_has_guaranties;
    },
    modules_has_guaranties_approve() {
      if (!this.user) {
        return false;
      }
      return this.user.role_settings.modules_has_guaranties_approve;
    },
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
    },
    CheckPers() {
      this.dialogPers = true;
      console.log(this.dialogPers);
    },
    GetColor(status) {
      return statusColors(status);
    },
    IsRemoteUrl(url) {
      return url.indexOf('://') !== -1;
    },
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl
        .post('profiles/api/auth/confirm-pers', {
          profile_id: app.user.profile_id,
        })
        .then(() => {
          this.$store.dispatch('GetProfile');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      if (app.user) {
        app.$store.getters.ax
          .post('profiles/api/register/info', { phone: app.user.phone_mobile })
          .then((response) => {
            app.pagePers = response.data.pagePers;
            app.pageRules = response.data.pageRules;
          });
      }
    },
    /** Загрузить список гарантий */
    loadCertificates() {
      if (!this.user || !(this.module_has_guaranties || this.modules_has_guaranties_approve)) {
        return;
      }
      this.$store.getters.axl
        .post('guaranties/api/guaranties/list', {
          profile_id: this.user.profile_id,
        })
        .then((response) => {
          this.certificates = response.data.guaranties;
        });
    },
    loadCounts() {
      if (!this.user || !(this.module_has_guaranties || this.modules_has_guaranties_approve)) {
        return;
      }
      const app = this;
      app.$store.getters.ax
        .post('profiles/api/profiles/get-count', {
          profile_id: this.user.profile_id,
        })
        .then((response) => {
          app.count.installations = response.data.installationsCount;
          app.count.guaranties = response.data.guarantiesCount;
          app.count.utilizations = response.data.utilizationsCount;
        });
    },
    ConfirmRules() {
      this.$store.dispatch('AgreeingRules');
    },
    CheckPromocode() {
      const app = this;
      if (app.promocode.length === 0) {
        app.$store.dispatch('ShowInfo', 'Не заполнено поле Промокод!');
        return;
      }
      if (app.promocode.length !== 10) {
        app.$store.dispatch('ShowInfo', 'Не верная длина Промокода!');
        return;
      }
      app.$store.getters.axl
        .post('/profiles/api/profiles/promocode', {
          profile_id: app.user.profile_id,
          code: app.promocode,
        })
        .then(() => {
          app.promocode = '';
          app.$store.dispatch('ShowInfo', 'Промокод успешно применен!');
          this.$store.dispatch('GetProfile');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    goToInstallerGuaranties(type) {
      this.$router.push({ name: 'installerGuaranties', params: { type } });
    },
    /** Преобразовать дату */
    convertDate(date) {
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
  created() {
    !this.user && this.$store.dispatch('GetProfile');
    !this.settings && this.$store.dispatch('GetSettings');
  },
  mounted() {
    this.LoadPers();
    this.loadCertificates();
    this.loadCounts();
  },
  watch: {
    user() {
      if (this.user && !this.loadUserData) {
        this.loadUserData = true;
        this.$store.dispatch('surveys/GetSurveys', this.user.profile_id);
        this.$store.dispatch('GetStatuses', this.user.profile_id);
        this.$store.dispatch(
          'notifications/GetNotifications',
          this.user.profile_id,
        );
        this.$store.dispatch('objects/GetObjects', {
          profile_id: this.user.profile_id,
        });
        this.$store.dispatch('CheckAgreedRules').then(() => {
          if (this.requirePers || this.requireRules) {
            this.LoadPers();
          }
        });
        this.loadCertificates();
        this.loadCounts();
        this.isBannersOn
          && this.$store.dispatch('banners/GetBannersList', this.user.profile_id);
      }
    },
  },
};
